/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { ManageListTab } from '@bvi/admin-panel/feature/manage-list/ui';
import { Stack } from '@mui/material';

export const ManageListPage = () => {
  return (
    <Stack direction="column">
      <ManageListTab />
    </Stack>
  );
};
